import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { useController } from 'react-hook-form';

interface Props extends ChakraV3.SwitchRootProps {
  name: string;
}

export const HookedSwitch = (props: Props) => {
  const { name, ...rest } = props;

  const {
    field: { ref, ...inputProps },
  } = useController({ name });

  return (
    <ChakraV3.Switch.Root
      {...rest}
      checked={inputProps.value}
      onCheckedChange={({ checked }) => inputProps.onChange(checked)}
    >
      <ChakraV3.Switch.HiddenInput />
      <ChakraV3.Switch.Control />
    </ChakraV3.Switch.Root>
  );
};
